<div class="container-fluid">
  <form [formGroup]="myOperationForm">
    <div class="row paddingContainerCamposFijos instDatosOperacion">
      <div class="col-md-6">
        <div class="inputBlock instConsumoEnergeticoAnual">
          <mat-label>{{
            "centro.centroData.anualEnergyConsmpt" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            [value]="this.centro?.conEnerAn"
            class="dataInput"
            formControlName="conEnerAn"
            [readonly]="!this.centro.edicionCentro && !this.parent?.isCreating"
            noDecimalNumber
          />
        </div>
        <div
          class="inputBlock select-container instBonificacionPenalizacionEnergetica"
        >
          <mat-label>{{
            "centro.centroData.energyBonus" | translate
          }}</mat-label>
          <mat-select
            class="dataInput"
            formControlName="primaIncluidaID"
            [disabled]="!this.centro?.edicionCentro && !this.parent?.isCreating"
          >
            <mat-option
              *ngFor="let item of primaIncluidaList"
              [value]="item.id"
            >
              {{ "centro.energyBonuses." + item.codigo | translate }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="inputBlock instConsumoEnergeticoAutoproducido">
          <mat-label>{{
            "centro.centroData.selfProducedEnergyConsmpt" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            [value]="this.centro?.conEnerAnAut"
            class="dataInput"
            formControlName="conEnerAnAut"
            [readonly]="!this.centro?.edicionCentro && !this.parent?.isCreating"
            noDecimalNumber
          />
        </div>
      </div>
    </div>

    <div class="row paddingContainer instDatosOperacion">
      <div class="col-md-6 instUsoPrincipalAguaRege">
        <div class="inputBlock instUsoPrincipalAguaRege">
          <mat-label>{{
            "centro.centroData.usoPriAguaRegeID" | translate
          }}</mat-label>
          <mat-select
            class="dataInput"
            formControlName="usoPriAguaRegeID"
            [disabled]="!this.centro?.edicionCentro && !this.parent?.isCreating"
          >
            <mat-option
              *ngFor="let item of usoAguaRegeneradaList"
              [value]="item.id"
            >
              {{ "centro.tipoAgua." + item.codigo | translate }}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <div class="col-md-6 instUsoPorcentajePpalRege">
        <div class="inputBlock instUsoPorcentajePpalRege">
          <mat-label>{{
            "centro.centroData.usoPriPorcRege" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            min="0.00"
            max="100.00"
            step="0.01"
            [value]="this.centro?.usoPriPorcRege"
            class="dataInput"
            formControlName="usoPriPorcRege"
            [readonly]="!this.centro?.edicionCentro && !this.parent?.isCreating"
            twoDecimalNumber
          />
          <mat-error
            *ngIf="
              (myOperationForm.get('usoPriPorcRege').hasError('max') ||
                myOperationForm.get('usoPriPorcRege').hasError('min')) &&
              myOperationForm.get('usoPriPorcRege').touched
            "
          >
            {{ "messages.maxminValue" | translate }}
          </mat-error>
        </div>
      </div>

      <div class="col-md-6 instUsoPrincipalAguaProd">
        <div class="inputBlock instUsoPrincipalAguaProd">
          <mat-label>{{
            "centro.centroData.usoPriAguaProdID" | translate
          }}</mat-label>
          <mat-select
            class="dataInput"
            formControlName="usoPriAguaProdID"
            [disabled]="!this.centro?.edicionCentro && !this.parent?.isCreating"
          >
            <mat-option
              *ngFor="let item of usoAguaProductoList"
              [value]="item.id"
            >
              {{ "centro.tipoAgua." + item.codigo | translate }}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <div class="col-md-6 instUsoPorcentajePpalProd">
        <div class="inputBlock instUsoPorcentajePpalProd">
          <mat-label>{{
            "centro.centroData.usoPriPorc" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            min="0.00"
            max="100.00"
            step="0.01"
            [value]="this.centro?.usoPriPorc"
            class="dataInput"
            formControlName="usoPriPorc"
            [readonly]="!this.centro?.edicionCentro && !this.parent?.isCreating"
            twoDecimalNumber
          />
          <mat-error
            *ngIf="
              (myOperationForm.get('usoPriPorc').hasError('max') ||
                myOperationForm.get('usoPriPorc').hasError('min')) &&
              myOperationForm.get('usoPriPorc').touched
            "
          >
            {{ "messages.maxminValue" | translate }}
          </mat-error>
        </div>
      </div>

      <div class="col-md-6 instUsoSecundarioAguaProd">
        <div class="inputBlock instUsoSecundarioAguaProd">
          <mat-label>{{
            "centro.centroData.usoSecAguaProdID" | translate
          }}</mat-label>
          <mat-select
            class="dataInput"
            formControlName="usoSecAguaProdID"
            [disabled]="!this.centro?.edicionCentro && !this.parent?.isCreating"
          >
            <mat-option
              *ngFor="let item of usoAguaProductoList"
              [value]="item.id"
            >
              {{ "centro.tipoAgua." + item.codigo | translate }}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <div class="col-md-6 instUsoPorcentajeSecundario">
        <div class="inputBlock instUsoPorcentajeSecundario">
          <mat-label>{{
            "centro.centroData.usoSecPorc" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            min="0.00"
            max="100.00"
            step="0.01"
            [value]="this.centro?.usoSecPorc"
            class="dataInput"
            formControlName="usoSecPorc"
            [readonly]="!this.centro?.edicionCentro && !this.parent?.isCreating"
            twoDecimalNumber
          />
          <mat-error
            *ngIf="
              (myOperationForm.get('usoSecPorc').hasError('max') ||
                myOperationForm.get('usoSecPorc').hasError('min')) &&
              myOperationForm.get('usoSecPorc').touched
            "
          >
            {{ "messages.maxminValue" | translate }}
          </mat-error>
        </div>
      </div>

      <div class="col-md-6 instProduccionAgua">
        <div class="inputBlock instProduccionAgua">
          <mat-label>{{
            "centro.centroData.waterProduced" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            [value]="this.centro?.producAgua"
            class="dataInput"
            formControlName="producAgua"
            [readonly]="!this.centro.edicionCentro && !this.parent?.isCreating"
          />
        </div>
      </div>

      <div class="col-md-6 instVolumenAguaDistribuida">
        <div class="inputBlock instVolumenAguaDistribuida">
          <mat-label>{{
            "centro.centroData.invoicedVolume" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            [value]="this.centro?.volumenFacturado"
            class="dataInput"
            formControlName="volumenFacturado"
            [readonly]="!this.centro.edicionCentro && !this.parent?.isCreating"
            noDecimalNumber
          />
        </div>
      </div>

      <div class="col-md-6 instVolumenCaudalRecogido">
        <div class="inputBlock instVolumenCaudalRecogido">
          <mat-label>{{
            "centro.centroData.collectedVolume" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            [value]="this.centro?.voluRecoSan"
            class="dataInput"
            formControlName="voluRecoSan"
            [readonly]="!this.centro.edicionCentro && !this.parent?.isCreating"
            noDecimalNumber
          />
        </div>
      </div>

      <div class="col-md-6 instILI">
        <div class="inputBlock instILI">
          <mat-label>{{ "centro.centroData.ili" | translate }}</mat-label>
          <input
            matInput
            type="number"
            step="0.01"
            [value]="this.centro?.iLI"
            class="dataInput"
            formControlName="iLI"
            [readonly]="!this.centro?.edicionCentro && !this.parent?.isCreating"
            twoDecimalNumber
          />
        </div>
      </div>

      <div class="col-md-6 instDesnitrificacion">
        <div class="inputBlock select-container instDesnitrificacion">
          <mat-label>{{
            "centro.centroData.denitrification" | translate
          }}</mat-label>
          <mat-select
            class="dataInput"
            formControlName="desnitrificacionID"
            [disabled]="!this.centro?.edicionCentro && !this.parent?.isCreating"
          >
            <mat-option
              *ngFor="let item of desnitrificacionList"
              [value]="item.id"
            >
              {{ "centro.desnitrifications." + item.codigo | translate }}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <div class="col-md-6 instPoblacionAbastecida">
        <div class="inputBlock instPoblacionAbastecida">
          <mat-label>{{
            "centro.centroData.poblaAbaste" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            [value]="this.centro?.poblaAbaste"
            class="dataInput"
            formControlName="poblaAbaste"
            [readonly]="!this.centro?.edicionCentro && !this.parent?.isCreating"
            noDecimalNumber
          />
        </div>
      </div>

      <div class="col-md-6 instDigestionAnaerobia">
        <div class="inputBlock select-container instDigestionAnaerobia">
          <mat-label>{{
            "centro.centroData.anaerobicDigestion" | translate
          }}</mat-label>
          <mat-select
            class="dataInput"
            formControlName="digestionAnaerobiaFangoID"
            [disabled]="!this.centro?.edicionCentro && !this.parent?.isCreating"
          >
            <mat-option
              *ngFor="let item of digestionAnaerobiaFangoList"
              [value]="item.id"
            >
              {{ "centro.anaerobicDigestions." + item.codigo | translate }}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <div class="col-md-6 instRecuperacionFosforo">
        <div class="inputBlock select-container instRecuperacionFosforo">
          <mat-label>{{
            "centro.centroData.retrieveMatch" | translate
          }}</mat-label>
          <mat-select
            class="dataInput"
            formControlName="recupFosforoID"
            [disabled]="!this.centro?.edicionCentro && !this.parent?.isCreating"
          >
            <mat-option
              *ngFor="let item of recuperacionFosforoList"
              [value]="item.id"
            >
              {{ "centro.retrieveMatches." + item.codigo | translate }}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <div class="col-md-6">
        <div class="inputBlock">
          <mat-label>{{
            "centro.centroData.cecoaCenter" | translate
          }}</mat-label>
          <input
            matInput
            type="text"
            class="dataInput"
            formControlName="cecoaCentro"
            [readonly]="!this.centro?.edicionCentro && !this.parent?.isCreating"
          />
        </div>
      </div>
    </div>
  </form>
</div>
